import { alpha } from "@mui/material/styles";
import { listClasses } from "@mui/material/List";
import { paperClasses } from "@mui/material/Paper";
import { buttonClasses } from "@mui/material/Button";
import { listItemIconClasses } from "@mui/material/ListItemIcon";
import { tablePaginationClasses } from "@mui/material/TablePagination";
//
import { paper } from "../../css";
// ----------------------------------------------------------------------
export function dataGrid(theme) {
    const paperStyles = paper({ theme, dropdown: true });
    return {
        MuiDataGrid: {
            styleOverrides: {
                root: {
                    borderWidth: 0,
                    "& .MuiDataGrid-cell": {
                        border: "none !important",
                    },
                    "& .MuiSvgIcon-root ": {
                        color: "rgba(69, 79, 91, 1)",
                    },
                    "& .MuiDataGrid-cell:focus": {
                        outline: "none",
                        border: "none",
                    },
                    "& .MuiDataGrid-cell:focus-within": {
                        outline: "none",
                        border: "none",
                    },
                    "& .MuiDataGrid-cell--editing": {
                        outline: "none",
                        border: "none",
                    },
                    "& .MuiDataGrid-cell--focus": {
                        outline: "none",
                        border: "none",
                    },
                    "& .MuiDataGrid-row": {
                        cursor: "pointer",
                        borderRadius: theme.spacing(2),
                    },
                    "& .MuiDataGrid-root .MuiDataGrid-columnHeaders": {
                        borderBottom: `1px solid red`,
                    },
                    ".MuiDataGrid-columnHeaderTitle": {
                        fontWeight: "600 !important",
                        overflow: "visible !important",
                        color: theme.palette.primary.dark,
                    },
                    [`& .${tablePaginationClasses.root}`]: {
                        borderTop: 0,
                    },
                    [`& .${tablePaginationClasses.toolbar}`]: {
                        height: "auto",
                        minHeight: 40,
                    },
                    [`& .${tablePaginationClasses.actions}`]: {
                        button: {
                            cursor: "pointer",
                            border: `1px solid ${theme.palette.divider}`,
                            borderRadius: theme.spacing(1.5),
                            padding: theme.spacing(0.5, 1),
                            margin: theme.spacing(0, 0.5),
                            "&.Mui-selected": {
                                backgroundColor: theme.palette.primary.main,
                                color: theme.palette.common.white,
                                borderColor: theme.palette.primary.main,
                            },
                            "&:hover": {
                                backgroundColor: alpha(theme.palette.primary.main, 0.1),
                            },
                        },
                    },
                    // "& .MuiDataGrid-container--top": {
                    //   borderBottom: `1px solid ${theme.palette.primary.light}`,
                    // },
                    "& .MuiDataGrid-row:nth-of-type(odd)": {
                        backgroundColor: "rgba(255, 255, 255, 0.8)",
                    },
                    "& .MuiDataGrid-row:nth-of-type(even)": {
                        backgroundColor: "rgba(49, 146, 208, 0.08)",
                    },
                    "& .MuiDataGrid-withBorderColor": {
                        borderColor: "transparent",
                    },
                    "--DataGrid-rowBorderColor": "transparent",
                    "--DataGrid-containerBackground": "transparent ",
                },
                footerContainer: {
                    minHeight: 44,
                },
                cell: {
                    borderBottom: "1px solid transparent ",
                    color: theme.palette.text.primary,
                },
                selectedRowCount: {
                    whiteSpace: "nowrap",
                },
                columnSeparator: {
                    color: theme.palette.divider,
                    display: "none",
                },
                toolbarContainer: {
                    padding: theme.spacing(2),
                    borderBottom: `1px solid transparent`,
                    backgroundColor: theme.palette.background.neutral,
                },
                paper: {
                    ...paperStyles,
                    padding: 0,
                },
                menu: {
                    [`& .${paperClasses.root}`]: {
                        ...paperStyles,
                    },
                    [`& .${listClasses.root}`]: {
                        padding: 0,
                        [`& .${listItemIconClasses.root}`]: {
                            minWidth: 0,
                            marginRight: theme.spacing(2),
                        },
                    },
                },
                columnHeaders: {
                    // borderRadius: 8,
                    borderBottom: `1px solid ${theme.palette.primary.light}`,
                    borderLeft: "none",
                    borderRight: "none",
                    background: "white",
                },
                panelHeader: {
                    padding: theme.spacing(2),
                },
                panelFooter: {
                    padding: theme.spacing(2),
                    justifyContent: "flex-end",
                    borderTop: "1px solid transparent",
                    borderColor: "transparent",
                    [`& .${buttonClasses.root}`]: {
                        "&:first-of-type": {
                        // border: `solid 1px ${alpha(theme.palette.grey[500], 0.24)}`,
                        },
                        "&:last-of-type": {
                            marginLeft: theme.spacing(1.5),
                            color: theme.palette.background.paper,
                            backgroundColor: theme.palette.text.primary,
                        },
                    },
                },
                filterForm: {
                    padding: theme.spacing(2),
                },
                filterFormValueInput: {
                    marginLeft: theme.spacing(2),
                },
                filterFormColumnInput: {
                    marginLeft: theme.spacing(2),
                },
                filterFormOperatorInput: {
                    marginLeft: theme.spacing(2),
                },
            },
        },
    };
}
